import Api from "./api";
import OidcManager from "./oidcManager";


export interface CustomerEstimate {
    id?: number;

    firstName?: string;
    middleInitial?: string;
    lastName?: string;
    company?: string;
    streetAddress?: string;
    streetAddress2?: string;
    city?: string;
    state?: string;
    zip?: string;
    phone?: string;
    email?: string;
}

export class CustomersEstimatesApi extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address)
    }

    load(command: {estimateId: number }): JQueryPromise<CustomerEstimate> {
        return super.get("/api/customer/estimate", command);
    }

    save(command: CustomerEstimate & { estimateId: number }): JQueryPromise<CustomerEstimate> {
        console.log("saveCustomerEstimate", command);
        return super.post("/api/customer/estimate", command);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/customers-estimates.ts